import styled from 'styled-components'
import tw from 'twin.macro'

export const SubMenu = styled.div`
  top: 3.5em;
  right: 1rem;
  z-index: 99;
  overflow: hidden;
`
export const Ul = styled.ul`
  max-height: 400px;
  overflow-y: auto;
  scrollbar-width: 5px;

  &::-webkit-scrollbar {
    width: 5px;
  }

  &::-webkit-scrollbar-thumb {
    ${tw`bg-gray-400 rounded-full`}
  }

  &::-webkit-scrollbar-track {
    box-shadow: inset 0 0 6px rgba(237, 242, 247, 0.1);
  }
`

export const FixedDiv = styled.div`
  box-shadow: 0px -1px 7px 0px rgba(160, 174, 192, 0.3);
`
